var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCcw01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56072 4.23023C5.5267 3.26359 6.85966 2.66683 8.33326 2.66683C11.2788 2.66683 13.6666 5.05464 13.6666 8.00016C13.6666 10.9457 11.2788 13.3335 8.33326 13.3335C5.90277 13.3335 3.8504 11.7072 3.20831 9.482C3.10623 9.12824 2.7367 8.92422 2.38294 9.0263C2.02919 9.12838 1.82516 9.49791 1.92724 9.85166C2.72961 12.6322 5.29296 14.6668 8.33326 14.6668C12.0152 14.6668 14.9999 11.6821 14.9999 8.00016C14.9999 4.31826 12.0152 1.3335 8.33326 1.3335C6.49167 1.3335 4.82341 2.08109 3.61759 3.28775C3.19354 3.71209 2.7372 4.23864 2.33333 4.72972V2.66683C2.33333 2.29864 2.03486 2.00016 1.66667 2.00016C1.29848 2.00016 1 2.29864 1 2.66683V6.66683C1 7.03502 1.29848 7.3335 1.66667 7.3335H5.66667C6.03486 7.3335 6.33333 7.03502 6.33333 6.66683C6.33333 6.29864 6.03486 6.00016 5.66667 6.00016H3.02049C3.47655 5.42779 4.05123 4.74008 4.56072 4.23023Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcw01);
export default __webpack_public_path__ + "static/media/refresh-ccw-01.4e7ac19664f60082f44e57a17d189c68.svg";
export { ForwardRef as ReactComponent };